// Shared helpers for rendering/normalizing the VCP pattern fields
// (vcp_length_weeks, vcp_times, vcp_high_pct, vcp_low_pct) used by the VCP
// page's row and pattern-editor components.

export const normalizeVcpNumber = (value) => {
  if (value === null || value === undefined || value === '') {
    return null;
  }
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
};

const formatVcpPart = (value) => {
  const parsed = normalizeVcpNumber(value);
  return parsed === null ? null : String(parsed);
};

export const getVcpDisplay = (item) => {
  const lengthWeeks = formatVcpPart(item?.vcp_length_weeks);
  const times = formatVcpPart(item?.vcp_times);
  const highPct = formatVcpPart(item?.vcp_high_pct);
  const lowPct = formatVcpPart(item?.vcp_low_pct);

  if (!lengthWeeks || !times || !highPct || !lowPct) {
    return '-';
  }

  return `${lengthWeeks}W-${highPct}/${lowPct}-${times}T`;
};
